import ConnectionStatus from "components/ConnectionStatus";

import { useGameContext } from "GameContext";
import { useWebSocket } from "WebSocketContext";

import { useNavigate } from "react-router-dom"

import React, { useEffect, useState } from "react";
import BackButton from "components/BackButton";
import BasicButton from "components/General/BasicButton";

const JoinGame: React.FC = () => {
  const { playerId, socket } = useWebSocket();
  const {
    gameId,
    setGameId,
    setHostId,
  } = useGameContext();

  const navigate = useNavigate()

  const [textVal, setText] = useState("");

  const [errorMessage, setErrorMessage] = useState("");

  function onMessage(event: { data: string; }) {
    if (event.data) {
      if (event.data) {
        const message = JSON.parse(event.data);
        if (message?.kind === "ErrorMessage" && message?.message === "GAME NOT FOUND") {
          setErrorMessage("No games found with that code")
        }

        if (message.kind === "JoinGameSuccess") {
          setHostId(message.hostId);
          setErrorMessage("")
          navigate("/play/join/player");
        }
      }
    }
  }

  useEffect(() => {
    if (!socket) return;
    socket.addEventListener("message", onMessage);

    return () => {
      if (socket) {
        socket.removeEventListener("message", onMessage);
      }
    }
  }, [socket]);


  function joinGame(val: string) {
    if (!val) {
      // enter invite code error message;
      console.log("No invite code");
      return;
    }

    if (playerId < 0) {
      console.log("No player id defined");
      return;
    }

    setGameId(val)

    const mes = JSON.stringify({
      kind: "RequestJoinGame",
      playerId: playerId,
      gameInviteCode: val,
    })
    socket?.send( mes );
  }

  const handleNext = () => {
    joinGame(textVal);
  }

  return (
    <div className="flex h-[100vh] w-full items-center justify-center">
      <ConnectionStatus />

      <div className="relative flex flex-col items-center">
        { errorMessage !== "" && (
          <div className="absolute bottom-0 translate-y-[100%]">
            <div className="mt-2 border-2 border-black p-6">
              <p className="text-sm">{errorMessage}</p>
            </div>
          </div>
        )}
        <label className="">Enter the invite code</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={textVal}
            onChange={(e) => setText(e.target.value)}
            className="bg-[#7fffff] p-2 text-lg outline-none"
          />
          <BasicButton
            onClick={handleNext}
            text={"Next"}
          />
        </div>
      </div>

      <BackButton/>
    </div>
  )
}

export default JoinGame;
